import * as React from "react";
import Style from "../../_data/models/Style";
import Meta from "../../_data/models/Meta";
import MyStylesGalleryComponent from "./MyStylesGalleryComponent";
import {OrderedMap} from "immutable";

interface Props {
    items: OrderedMap<number, Style>;
    meta: Meta;
    loading: boolean;
    loadMore: (meta: Meta) => void;
    errors: string[];
    scrollPosition:number;
}

const scrollToLastScrollPosition = (props:Props)=> {    
    window.scrollTo(0,props.scrollPosition);
}

const MyStylesComponent = (props: Props) => {
    let {items} = props;    

    return (
        <div className="row" onLoad={ () => {
            scrollToLastScrollPosition(props)         
        }}>
            <div className="large-12 columns">
                <div className="callout mt-1">             
                    <MyStylesGalleryComponent {...props}/>
                </div>
            </div>
        </div>
    );
};

export default MyStylesComponent;


// WEBPACK FOOTER //
// ./app/client/style/components/MyStylesComponent.tsx